import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
      <Typography variant="h3" gutterBottom>404 – Seite nicht gefunden</Typography>
      <Typography variant="body1" gutterBottom>Die angeforderte Seite existiert nicht.</Typography>
      <Button variant="contained" color="primary" onClick={() => navigate("/")}>
        Zurück zur Startseite
      </Button>
    </Box>
  );
};

export default NotFound;